<template>
  <div>
    <v-autocomplete
      v-model="local.signer"
      :items="signers"
      item-value="euid"
      :item-text="item => nvl(item.chinStaffName,'') + ((item.chinStaffName&&item.portStaffName)?' ':'') + nvl(item.portStaffName,'') + (item.nickName?' ('+item.nickName+')':'') + ' ' + item.euid + (item.isAbsent?' - '+$t('Outbox.absence'):'')"
      hide-details
      :label="$t('Outbox.Signer')"
    />
    <!-- <v-select
      v-model="local.signer"
      :items="signers"
      item-value="staffCode"
      :item-text="item => item.chinStaffName + ' ' + item.portStaffName + (item.isAbsent?' ('+$t('Outbox.absence')+')':'')"
      hide-details
      :label="$t('Outbox.Signer')"
    /> -->
  </div>
</template>

<script>

import outboxApi from '@/api/outbox/outbox'
import { nvl } from '@/utils/stringUtil'
import { isArrayEmptyOrNull } from '@/utils/arrayUtil'
import jwtTokenApi from '@/api/general/jwtToken'
import { mapState } from 'vuex'
import { globalModule, staffModule } from '@/store/moduleName'

function getOficioSigners (inst) {
  outboxApi.getOficioSigners(resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.signers = resp.data
    }
  })
}

export default {
  props: {
    value: {
      type: Object,
      default: null
      // {
      //   ...
      //   signer: null
      // },
    }
  },
  data: () => {
    return {
      signers: []
    }
  },
  computed: {
    local () {
      return this.value ? this.value : {
        signer: null
      }
    },
    ...mapState(
      {
        staff: state => state[staffModule].info // loaded at the Create.vue
      }
    )
  },
  watch: {
    'value.signer': async function (val) {
      await this.onSignerChange(val)
    },
    'value.isEncryptDoc': async function (val) {
      await this.onSignerChange(this.value.signer)
    }
  },
  created () {
    getOficioSigners(this)
  },
  methods: {
    nvl,
    async onSignerChange (val) {
      if (this.value.isEncryptDoc && !this.$config.isEncryptDynamicFlow) {
        this.local.nextStaff = val
      }
      if (this.value.isEncryptDoc && this.$config.isEncryptDynamicFlow) {
        this.value.openerList = []
        if (val) {
          let signer = this.signers.find((element) => element.euid === val)
          await jwtTokenApi.getPublicKeys([val], resp => {
            if (resp.status === 201 || resp.status === 200) {
              if (!isArrayEmptyOrNull(resp.data)) {
                this.value.openerList = [{
                  euid: this.staff.euid,
                  chinName: this.staff.chinName,
                  portName: this.staff.portName
                }]
                if (signer && signer.euid !== this.staff.euid) {
                  this.value.openerList.push({
                    euid: signer.euid,
                    chinName: signer.chinStaffName,
                    portName: signer.portStaffName
                  })
                }
              } else {
                this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('encrypt.msgUserKeyPairNotSetup') + '：' + this.$chPtObjData('chinStaffName', signer))
                this.value.signer = null
              }
            }
          })
        }
      }
    }
    // update (key, value) {
    //   this.$emit('input', { ...this.local, [key]: value })
    // }
  }
}
</script>
